import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  MenuItem,
  TextField,
} from "@mui/material";
import { useMemo, useState } from "react";
import { changeType } from "../../constants/labels";

const initialForm = {
  orderLineId: "",
  changeType: "DUE_DATE",
  requestedDueDate: "",
  quantity: "",
  itemName: "",
  specification: "",
  requestReason: "",
};

export const OssChangeRequestDialog = ({ open, orders = [], loading, onClose, onSubmit }) => {
  const [form, setForm] = useState(initialForm);
  const target = useMemo(
    () => orders.find((item) => String(item.order_line_id) === String(form.orderLineId)),
    [orders, form.orderLineId]
  );
  const update = (key, value) => setForm((prev) => ({ ...prev, [key]: value }));

  const submit = () => {
    if (!target) return;
    onSubmit({
      orderId: target.order_id,
      orderLineId: target.order_line_id,
      changeType: form.changeType,
      requestReason: form.requestReason,
      requestedByUserKey: "order.manager",
      after: {
        requestedDueDate: form.requestedDueDate || undefined,
        quantity: form.quantity || undefined,
        itemName: form.itemName || undefined,
        specification: form.specification || undefined,
      },
    }).then(() => setForm(initialForm));
  };

  const inputSx = {
    "& .MuiOutlinedInput-root": {
      minHeight: 42,
      alignItems: "center",
    },
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle
        sx={{
          px: 2.75,
          py: 2,
          pr: 6,
          fontSize: 19,
          fontWeight: 900,
          color: "#111827",
          borderBottom: "1px solid #e5e7eb",
        }}
      >
        변경 요청 등록
        <IconButton onClick={onClose} sx={{ position: "absolute", right: 14, top: 12 }}>
          <CloseRoundedIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 2.75, bgcolor: "#fbfbfe" }}>
        <Box sx={{ p: 1.6, border: "1px solid #e5e7eb", borderRadius: "8px", bgcolor: "#fff" }}>
          <Grid container spacing={1.2} alignItems="flex-start">
            <Grid item xs={12}>
              <TextField select fullWidth size="small" label="대상 주문 품목" value={form.orderLineId} onChange={(e) => update("orderLineId", e.target.value)} sx={inputSx}>
                {orders.map((order) => (
                  <MenuItem key={order.order_line_id} value={order.order_line_id}>
                    {order.order_no} / {order.item_name_snapshot} / 납기 {order.requested_due_date}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField select fullWidth size="small" label="변경 유형" value={form.changeType} onChange={(e) => update("changeType", e.target.value)} sx={inputSx}>
                {Object.entries(changeType).map(([value, label]) => (
                  <MenuItem key={value} value={value}>
                    {label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField fullWidth size="small" type="date" label="변경 후 납기" InputLabelProps={{ shrink: true }} value={form.requestedDueDate} onChange={(e) => update("requestedDueDate", e.target.value)} sx={inputSx} />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField fullWidth size="small" type="number" label="변경 후 수량" value={form.quantity} onChange={(e) => update("quantity", e.target.value)} sx={inputSx} />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField fullWidth size="small" label="변경 후 품목명" value={form.itemName} onChange={(e) => update("itemName", e.target.value)} sx={inputSx} />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField fullWidth size="small" label="변경 후 규격" value={form.specification} onChange={(e) => update("specification", e.target.value)} sx={inputSx} />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth multiline minRows={3} label="변경 사유" value={form.requestReason} onChange={(e) => update("requestReason", e.target.value)} />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 2.75, py: 1.6, borderTop: "1px solid #e5e7eb" }}>
        <Button onClick={onClose}>취소</Button>
        <Button variant="contained" disabled={loading || !target} onClick={submit}>
          등록
        </Button>
      </DialogActions>
    </Dialog>
  );
};
